import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function Shift(props) {
    const { t } = useTranslation("translation");
    return (
        <Autocomplete
            id="cpm_Shift_Autocomplete"
            value={props.selectedShiftType}
            defaultValue={""}
            style={{ marginTop: -25 }}
            onChange={(event, newValue) => {
                props.HandleShift(newValue);
            }}
            options={props.shiftData.map((option) => option.shiftNo.toString())}
            renderInput={(params) => (
                <TextField
                    id="cpm_TextField_5"
                    {...params}
                    margin="normal"
                    label={t("Shift")}
                    variant="outlined"
                    error={props.error ? props.error.shiftText.length > 0 : null}
                    helperText={props.error ? props.error.shiftText : null}
                />
            )}
        />
    );
}
